import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { EnhanceMessageBodySchema, EnhancedMessageResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type EnhanceMessageParams = {
  conversationId: string
  content: string
}

type UseEnhanceMessageMutationProps = {
  onError?: (error: Error) => void
}

type EnhanceMessageResponse = DataResponse<z.infer<typeof EnhancedMessageResponseDataSchema>>

export function useEnhanceMessageMutation(props: UseEnhanceMessageMutationProps = {}) {
  return useMutation<EnhanceMessageResponse, Error, EnhanceMessageParams>({
    mutationFn: async (params) => {
      // Validate input
      EnhanceMessageBodySchema.parse({ content: params.content })
      const response = await axios.post<EnhanceMessageResponse>(
        `/conversations/${params.conversationId}/enhance`,
        { content: params.content },
      )

      // Validate output
      EnhancedMessageResponseDataSchema.parse(response.data.data)
      return response.data
    },
    onError: (err) => props.onError?.(err),
  })
}
